// frontend/src/pages/MatchScoring/ScoreBlock.js
import React from 'react';
import { fmtStartedAt, fmtElapsed } from './useMatchState';

function oversFromBalls(balls) {
  const ov = Math.floor(balls / 6);
  const rem = balls % 6;
  return `${ov}.${rem}`;
}

export default function ScoreBlock({ currentInnings, liveState, allInnings, now }) {
  if (!currentInnings) return null;

  const total  = parseInt(currentInnings.total_runs || 0, 10);
  const wkts   = parseInt(currentInnings.wickets || 0, 10);
  const balls  = parseInt(currentInnings.legal_balls || 0, 10);
  const ov     = oversFromBalls(balls);
  const max    = currentInnings.max_overs || 0;
  const rr     = balls > 0 ? (total / (balls / 6)).toFixed(2) : '0.00';

  // Target / RRR if 2nd innings chasing
  let targetTag = null, rrrTag = null;
  if (currentInnings.target_runs) {
    const target = currentInnings.target_runs;
    const need = Math.max(0, target - total);
    targetTag = `Target ${target}`;
    if (max && balls < max * 6) {
      const ballsLeft = max * 6 - balls;
      const rrr = ballsLeft > 0 ? ((need / ballsLeft) * 6).toFixed(2) : '∞';
      rrrTag = `Need ${need} in ${ballsLeft} (RRR ${rrr})`;
    }
  }

  // Free hit?
  const isFreeHit = !!liveState?.pending_free_hit;

  return (
    <div className="sc-score">
      <div className="sc-score-tags">
        {isFreeHit && <span className="sc-tag-fh">⚡ FREE HIT</span>}
        {targetTag && <span className="sc-tag-target">{targetTag}</span>}
      </div>
      <div className="sc-score-line1">
        <div className="sc-score-total">
          {total}/<span className="sc-wkts">{wkts}</span>
        </div>
        <div className="sc-score-overs">
          (<strong>{ov}</strong>{max ? ` / ${max}` : ''})
        </div>
      </div>
      <div className="sc-score-meta">
        <span><span className="sc-k">RR</span><span className="sc-v">{rr}</span></span>
        {rrrTag && <span><span className="sc-k">CHASE</span><span className="sc-v">{rrrTag}</span></span>}
      </div>
      {/* Push 2 (Session 21 — 26 May 2026): innings start time + live elapsed. */}
      {currentInnings.started_at && (
        <div className="sc-score-meta" style={{ marginTop: 2 }}>
          <span><span className="sc-v">{fmtStartedAt(currentInnings.started_at)}</span></span>
          <span><span className="sc-k">ELAPSED</span><span className="sc-v">{fmtElapsed(currentInnings.started_at, now)}</span></span>
        </div>
      )}
    </div>
  );
}
